export default __webpack_public_path__ + "static/media/error-bg.cf7eceb7.jpg";